export function appendHttp(url: string) {
  return url.startsWith("http") || url.startsWith("https")
    ? url
    : `https://${url}`;
}
